import React from 'react';
import useLocale from '@/hooks/useLocale';
import type { LocaleWithGatorProtectPendingInvoice } from '../../../gatorProtect.types';
import {
  ProtectionCardRoot,
  ProtectionCardBody,
  ProtectionCardShield,
  ProtectionCardTextBlock,
  ProtectionCardTitle,
  ProtectionCardDescription,
  ProtectionCardActions,
  ProtectionCardMonarx,
  ProtectionCardButtonLink,
} from '../ProtectionCardCompound';

export const PENDING_INVOICE_PROTECTION_CARD_TYPE = 'pendingInvoice' as const;
export type PendingInvoiceProtectionCardType = typeof PENDING_INVOICE_PROTECTION_CARD_TYPE;

export type PendingInvoiceVariantProps = {
  testId?: string;
  onPendingInvoiceClick?: () => void;
};

const PendingInvoiceVariant = ({
  testId,
  onPendingInvoiceClick,
}: PendingInvoiceVariantProps) => {
  const { gatorProtect } = useLocale() as LocaleWithGatorProtectPendingInvoice;
  const summary = gatorProtect && gatorProtect.summary;
  const block = summary && summary.protectionCard && summary.protectionCard.pendingInvoice;

  if (!block) {
    return null;
  }

  const actionsTestId = `${testId}__actions`;

  const handlePendingInvoiceClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (onPendingInvoiceClick) {
      onPendingInvoiceClick();
    }
    return null;
  };

  return (
    <ProtectionCardRoot testId={testId}>
      <ProtectionCardBody>
        <ProtectionCardShield title={block.title} />
        <ProtectionCardTextBlock>
          <ProtectionCardTitle>{block.title}</ProtectionCardTitle>
          <ProtectionCardDescription html={block.description} />
          <ProtectionCardActions actionsTestId={actionsTestId}>
            <ProtectionCardButtonLink
              onClick={handlePendingInvoiceClick}
              testId={`${testId}__action-goToInvoices`}
            >
              {block.goToInvoices}
            </ProtectionCardButtonLink>
          </ProtectionCardActions>
        </ProtectionCardTextBlock>
      </ProtectionCardBody>
      <ProtectionCardMonarx title={block.title} />
    </ProtectionCardRoot>
  );
};

export default PendingInvoiceVariant;
